/**
 * Mini App 启动期后端预热（解决 Render Free 冷启 + Neon Free autosuspend 唤醒延迟）。
 *
 * 配套 docs/deployment/cost-optimized.md §3.1：
 *  - 极致低成本方案下 api-server / DB 会休眠；Mini App 加载时就**异步**唤醒
 *  - 用户从 Splash → 实际进首页（~500–1500 ms）这段时间，恰好覆盖大部分冷启耗时
 *
 * 设计原则：
 *  - 完全 fire-and-forget：任何失败 / 超时都不影响 UI 渲染
 *  - 不携带 token：/health 是公开端点
 *  - 同时打 /health（醒 api-server）与 /health/db（醒 Neon Postgres）
 *  - keepalive: true：即便用户立刻切走页面也不打断这两个请求
 */
import { API_BASE_URL } from './api';

let warmedUp = false;

export function warmupBackend(): void {
  if (warmedUp || !API_BASE_URL) return;
  warmedUp = true;

  const opts: RequestInit = { method: 'GET', keepalive: true, cache: 'no-store' };
  void fetch(`${API_BASE_URL}/health`, opts).catch(() => {});
  void fetch(`${API_BASE_URL}/health/db`, opts).catch(() => {});
}
